/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState, ProfileTypes } from 'store/modules/profile_store/types';
import NotificationsMenuNew from 'components/molecules/notification_menu_new';
import HeaderUserMenu from 'components/molecules/header_user_menu';
import ExternalRoutes from 'services/external_routes';
import { MenusBehaviourState } from 'store/modules/menus_behaviour_store/types';
import { PanelState } from 'store/modules/panel_store/types';
import { Link } from 'react-router-dom';
import CompanyMultiSelect from 'components/molecules/company_multi_select';
import CompanySelectNew from 'components/atoms/company_select_new';
import { ActivitiesState } from 'store/modules/activities_store/types';
import { fetchActivities } from 'store/modules/activities_store/actions';
import LogoConlicitaVerde from 'assets/images/header/icon-conlicitacao.svg';
import LogoConlicitaDourado from 'assets/images/header/icon-conlicitacao-gold.svg';
import ToolList from 'components/molecules/tool_list';
import { MonitoringState } from 'store/modules/monitoring_store/types';
import ChatbotAssistantIcon from 'components/atoms/chatbot_assistant_icon';
import AcademyLiveChip from 'components/molecules/academy_live_chip';
import { getNotificationsUnread } from 'store/modules/monitoring_store/actions';
import tabId from 'services/tabId';
import companyId from 'services/company_id';
import useToolsMenuHotkey from 'hooks/useToolsMenuHotkey';
import { REPRESENTANT_MENU_TOOLS } from 'services/representant_tools';
import { canUseRepresentantPlatform } from 'services/alfa_tools';
import { useAmbassadorInviteBanner } from 'hooks/useAmbassadorInviteBanner';
import LockedOverlay from 'components/atoms/locked_overlay';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { isConlicitasegAllowedRoute } from 'services/conlicitaseg_only_routes';
import { Nav, Box } from './styles';
import ChatbotAssistant from '../chatbot_assistant';

interface HeaderProps {
  offlineMode?: boolean;
}

const HeaderDefault = (props: HeaderProps) => {
  const { offlineMode } = props;
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const [isToolsOpen, setIsToolsOpen] = useState(false);
  const [isDashboardsOpen, setIsDashboardsOpen] = useState(false);
  const [isMyAccountOpen, setIsMyAccountOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [isRepToolsOpen, setIsRepToolsOpen] = useState(false);
  const repToolsRef = useRef<HTMLDivElement>(null);

  const closeMenus = (keepNotifications = false) => {
    setIsToolsOpen(false);
    setIsDashboardsOpen(false);
    setIsMyAccountOpen(false);
    setIsRepToolsOpen(false);
    if (!keepNotifications) setIsNotificationsOpen(false);
  };
  const showAmbassadorInvite = useAmbassadorInviteBanner();
  const isAmbassador = Boolean(profile?.ambassador?.member) && !profile.representant;

  const { menus_behaviour } = useSelector<ApplicationState, MenusBehaviourState>(
    (state) => state.session.menus_behaviour,
  );

  const { activities } = useSelector<ApplicationState, ActivitiesState>(
    (state) => state.storage.activities,
  );
  const { monitoring, request } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );
  const isOnlyConlicitaseg = useOnlyConlicitaseg();
  const isLockedRoute = (route: string) => isOnlyConlicitaseg && !isConlicitasegAllowedRoute(route);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNotificationsUnread(companyId(profile)));
  }, [dispatch, companyId(profile)]);

  const fetchAllActivities = () => {
    if (profile?.representant) {
      const missingActivities = profile?.represented?.find((company) => {
        if (!activities[company.id.toString()]) return company;
        if (activities[company.id.toString()].length === 0) return company;
        return false;
      });
      if (missingActivities) dispatch(fetchActivities());
    }

    if (!profile?.representant) {
      if (
        !activities[profile.clientId.toString()] ||
        activities[profile.clientId.toString()].length === 0
      )
        dispatch(fetchActivities());
    }
  };

  useEffect(() => {
    dispatch({ type: ProfileTypes.UPDATE_STORE_FIELDS });

    if (offlineMode) return;

    fetchAllActivities();
  }, []);

  useEffect(() => {
    if (!menus_behaviour.chatbotAssistant) return;

    closeMenus();
  }, [menus_behaviour.chatbotAssistant]);

  useEffect(() => {
    dispatch(
      getNotificationsUnread(
        profile.representant ? profile.currentCompany[tabId()] : profile.clientId,
      ),
    );
  }, []);

  useEffect(() => {
    dispatch(
      getNotificationsUnread(
        profile.representant ? profile.currentCompany[tabId()] : profile.clientId,
      ),
    );
  }, [profile.currentCompany[tabId()]]);

  useToolsMenuHotkey({
    isOpen: isToolsOpen,
    close: () => setIsToolsOpen(false),
  });

  useEffect(() => {
    if (!isRepToolsOpen) return undefined;

    const closeOnOutsideClick = (event: MouseEvent) => {
      if (!repToolsRef.current?.contains(event.target as Node)) setIsRepToolsOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, [isRepToolsOpen]);

  if (offlineMode)
    return (
      <Nav className="bg-header d-flex justify-content-end align-items-center fixed-top mb-0 d-print-none">
        <ul className="navbar-nav align-items-center flex-row">
          <li className="nav-item">
            <Link className="btn btn-success btn-sm" to="/cadastro">
              Cadastre-se
            </Link>
          </li>
          <li className="nav-item">
            <Link className="btn btn-link mx-2 btn-sm" to="/users/login">
              Acessar
            </Link>
          </li>
        </ul>
      </Nav>
    );

  return (
    <>
      <Nav
        className={`${profile.representant ? 'representant-header' : 'bg-header'} ${
          isAmbassador ? 'ambassador-header' : ''
        } d-flex align-items-center flex-wrap fixed-top mb-0 d-print-none ${
          profile.in_sample ? 'hasTopBanner' : ''
        } ${panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''} ${
          showAmbassadorInvite ? 'hasAmbassadorBanner' : ''
        }`}
      >
        <div className="d-flex order-1 align-items-center py-0 h-100">
          <div className="box-logo d-flex justify-content-between align-items-center">
            <Link title="Logo" className="icon-logo" to="/painel">
              <img
                alt="Tudo sobre Licitações Públicas e Pregão - Conlicitação"
                src={isAmbassador ? LogoConlicitaDourado : LogoConlicitaVerde}
                width="42"
              />
            </Link>
          </div>
          {profile?.alfa_tester ? (
            <div className="position-relative">
              <a
                className="nav-link nav-link-menu d-md-flex d-none px-3 py-0 align-items-center dropdown-toggle"
                role="button"
                href="#"
                onClick={() => {
                  closeMenus();
                  setIsDashboardsOpen(!isDashboardsOpen);
                }}
              >
                Dashboards
              </a>
              <ul className={`dropdown-menu dropdown-menu-left ${isDashboardsOpen && 'show'}`}>
                <li className="nav-item">
                  <Link to="/" className="dropdown-item" target="_top">
                    Dashboard Inicial
                  </Link>
                </li>
                <li className="dropdown-divider" />
                <li className="nav-item">
                  <h6 className="dropdown-header">Robo de Lances</h6>
                </li>
                <li className="nav-item">
                  {isLockedRoute('/robo_dashboard/online') ? (
                    <LockedOverlay variant="inline" className="d-block">
                      <span className="dropdown-item">Usuários Online</span>
                    </LockedOverlay>
                  ) : (
                    <a className="dropdown-item" target="_top" href="/robo_dashboard/online">
                      Usuários Online
                    </a>
                  )}
                </li>
                <li className="nav-item">
                  {isLockedRoute('/robo_dashboard/usuarios') ? (
                    <LockedOverlay variant="inline" className="d-block">
                      <span className="dropdown-item">Usuários</span>
                    </LockedOverlay>
                  ) : (
                    <a className="dropdown-item" target="_top" href="/robo_dashboard/usuarios">
                      Usuários
                    </a>
                  )}
                </li>
                <li className="nav-item">
                  {isLockedRoute('/robo_dashboard/licitacoes') ? (
                    <LockedOverlay variant="inline" className="d-block">
                      <span className="dropdown-item">Licitações</span>
                    </LockedOverlay>
                  ) : (
                    <a className="dropdown-item" target="_top" href="/robo_dashboard/licitacoes">
                      Licitações
                    </a>
                  )}
                </li>
              </ul>
            </div>
          ) : (
            <Link
              to="/"
              className="btn-menu d-md-flex d-none"
              onClick={() => {
                closeMenus();
                setIsDashboardsOpen(true);
              }}
            >
              Dashboard
            </Link>
          )}

          <Link
            to="#"
            className={`btn-menu ${isToolsOpen ? 'tools' : ''}`}
            onClick={() => {
              closeMenus();
              setIsToolsOpen(!isToolsOpen);
            }}
          >
            <span className="material-icons d-inline-block d-md-none">menu</span>
            <span className="d-md-inline-block d-none">Ferramentas</span>
          </Link>
          {isToolsOpen && <ToolList />}
          {canUseRepresentantPlatform(profile) && (
            <div className="position-relative" ref={repToolsRef}>
              <Link
                to="#"
                className="btn-menu"
                aria-label="Ferramentas Representante"
                aria-expanded={isRepToolsOpen}
                onClick={() => {
                  closeMenus();
                  setIsRepToolsOpen(!isRepToolsOpen);
                }}
              >
                <span className="material-icons d-inline-block d-md-none">business_center</span>
                <span className="d-md-inline-block d-none">Ferramentas Representante</span>
              </Link>
              <ul
                className={`dropdown-menu dropdown-menu-left representant-tools-menu ${
                  isRepToolsOpen && 'show'
                }`}
              >
                {REPRESENTANT_MENU_TOOLS.map((tool) => (
                  <li className="nav-item" key={tool.id}>
                    <Link
                      to={tool.link}
                      className="dropdown-item"
                      onClick={() => setIsRepToolsOpen(false)}
                    >
                      {tool.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        {profile.representant &&
          (canUseRepresentantPlatform(profile) ? (
            <CompanyMultiSelect callbackSelect={() => closeMenus()} />
          ) : (
            profile.represented?.length > 0 && (
              <CompanySelectNew callbackSelect={() => closeMenus()} />
            )
          ))}
        <ul className="navbar-nav order-2 order-md-3 flex-fill justify-content-end align-items-center flex-row">
          {profile?.alfa_tester && (
            <li className="nav-item mx-2 d-none d-md-inline-block">
              <AcademyLiveChip />
            </li>
          )}
          {profile && profile.in_analysis && (
            <li className="nav-item mx-2">
              <a
                className="btn btn-sm btn-success"
                target="_top"
                href={ExternalRoutes.usuario.planos_precos}
              >
                {panel.partner_id ? 'Experimente o ConLicitação' : 'Assinar o ConLicitação'}
              </a>
            </li>
          )}
          <li className="nav-item text-center new-header-chatbot">
            <ChatbotAssistantIcon />
          </li>
          <li className="nav-item icon-header px-3">
            {isLockedRoute('/facilitadores/monitoramento') ? (
              <LockedOverlay variant="inline">
                <span className="d-flex menu-monitoring">
                  <span className="material-icons">chat_bubble</span>
                </span>
              </LockedOverlay>
            ) : (
              <Link
                to="/facilitadores/monitoramento"
                className="d-flex menu-monitoring databalloon"
                aria-label={
                  request?.get_notifications_unread?.loaded && monitoring?.notifications_unread
                    ? 'Novas mensagens no Monitorar Chat'
                    : 'Você não tem novas mensagens no Monitorar Chat'
                }
                data-balloon-pos="down"
              >
                <span className="material-icons">chat_bubble</span>
                {request?.get_notifications_unread?.loaded && monitoring?.notifications_unread && (
                  <span className="monitoring-notify position-absolute p-1 bg-danger border border-light rounded-circle" />
                )}
              </Link>
            )}
          </li>
          <li className="nav-item icon-header dropdown px-3 position-relative" id="notification">
            <NotificationsMenuNew
              callback={() => closeMenus(true)}
              isNotificationsOpen={isNotificationsOpen}
              setIsNotificationsOpen={setIsNotificationsOpen}
            />
          </li>
          <li className="nav-item d-md-inline-block d-none">
            <Link className="btn btn-sm btn-primary tour-ajuda-button mx-2" to="/ajuda">
              Ajuda
            </Link>
          </li>
          <HeaderUserMenu
            isOpen={isMyAccountOpen}
            onToggle={() => {
              closeMenus();
              setIsMyAccountOpen(!isMyAccountOpen);
            }}
          />
        </ul>
      </Nav>
      <Box
        className={`${isToolsOpen && 'menu-open'} bg-open`}
        onClick={() => setIsToolsOpen(false)}
        aria-hidden="true"
      />
      <ChatbotAssistant />
    </>
  );
};

export default HeaderDefault;
